import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEyeSlash24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "m19.293 20.707-16-16 1.414-1.414L7.49 6.075A2.5 2.5 0 0 1 8.1 6h7.8c.701 0 1.37.294 1.843.81l3.518 3.839a2 2 0 0 1 0 2.702l-3.106 3.39 2.552 2.552zM11.086 9.672 9.414 8H15.9a.5.5 0 0 1 .369.162L19.787 12l-3.048 3.325-2.411-2.411a2.5 2.5 0 0 0-3.242-3.241",
			clipRule: "evenodd"
		}), /* @__PURE__ */ _jsx("path", { d: "M6.544 9.458 4.214 12l3.517 3.838A.5.5 0 0 0 8.1 16h4.986l2 2H8.1a2.5 2.5 0 0 1-1.843-.81L2.739 13.35a2 2 0 0 1 0-2.703l2.389-2.606z" })]
	})
});
const ForwardRef = forwardRef(SvgIconEyeSlash24);
export default ForwardRef;
